<script setup lang="ts">
import { AvatarRoot } from 'radix-vue'
import type { HTMLAttributes } from 'vue'

import { cn } from '@/utils'

import { avatarVariant, type AvatarVariants } from '.'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    size?: AvatarVariants['size']
    shape?: AvatarVariants['shape']
  }>(),
  {
    size: 'sm',
    shape: 'circle',
    class: '',
  }
)
</script>

<template>
  <AvatarRoot :class="cn(avatarVariant({ size, shape }), props.class)" as="div">
    <slot />
  </AvatarRoot>
</template>
